import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axiosInstance from 'utils/axiosInterceptors';
import { toastConfig } from 'utils/toastConfig';
import * as yup from 'yup';

type ReleaseCheckFormProps = {
  branchDomain: string;
  supplierPaymentId: string;
};

const ReleaseCheckForm = React.forwardRef<
  { submitForm: () => Promise<boolean | undefined> },
  ReleaseCheckFormProps
>(({ branchDomain, supplierPaymentId }, ref) => {
  const [checkReleasedTo, setCheckReleasedTo] = useState<string>('');

  const schema = yup.object().shape({
    checkReleasedTo: yup.string().required('Release to field is required')
  });

  const handleSubmit = async () => {
    try {
      await schema.validate({ checkReleasedTo }, { abortEarly: false });
      await axiosInstance.put(
        `/api/v1/${branchDomain}/supplierPayments/${supplierPaymentId}/releaseCheck`,
        { checkReleasedTo: checkReleasedTo }
      );
      toast.success('Check released', { ...toastConfig, autoClose: 2000 });
      return true;
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        error.inner.forEach(err => {
          toast.error(err.message, { ...toastConfig, autoClose: 3000 });
        });
      } else if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
    }
  };

  React.useImperativeHandle(ref, () => ({
    submitForm: handleSubmit
  }));

  return (
    <>
      <Form className="w-100">
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Release to</Form.Label>
            <Form.Control
              type="text"
              value={checkReleasedTo}
              onChange={e => setCheckReleasedTo(e.target.value)}
            />
          </Form.Group>
        </Row>
      </Form>
    </>
  );
});

export default ReleaseCheckForm;
